var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { observable, action, computed } from 'mobx';
import find from 'ramda/src/find';
import { customerioTracker } from 'lib';
import { analyticsTracker } from 'utils';
import UserStore from './UserStore';
let PanelStore = (_class = class PanelStore {
  constructor() {
    _initializerDefineProperty(this, "selectedPanel", _descriptor, this);
    _initializerDefineProperty(this, "isReload", _descriptor2, this);
    _initializerDefineProperty(this, "setSelectedPanel", _descriptor3, this);
    _initializerDefineProperty(this, "getBrandByPanelId", _descriptor4, this);
    _initializerDefineProperty(this, "trackPin", _descriptor5, this);
  }
  get panelOptions() {
    const options = UserStore.get('brands');
    return options?.length ? options : [];
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "selectedPanel", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "panelOptions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "panelOptions"), _class.prototype), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isReload", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "setSelectedPanel", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return brand => {
      this.selectedPanel = brand;
      if (this.selectedPanel) this.selectedPanel.panelId = brand?.panels?.[0]?.id || '';
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "getBrandByPanelId", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return panelId => find(brand => brand.panels?.[0]?.id === panelId)(this.panelOptions);
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "trackPin", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return ({
      pinTitle,
      workspaceId,
      pinType,
      pinStatus,
      location = false,
      topicTitle = false
    }) => {
      const workspace = this.getBrandByPanelId(workspaceId);
      const {
        ADD_TO
      } = analyticsTracker.eventNames;
      const {
        INSIGHT_SAVED
      } = customerioTracker.eventNames;
      customerioTracker.track(INSIGHT_SAVED, {
        content_added: pinType
      });
      analyticsTracker.eventTrack(ADD_TO, {
        'Content added': pinType,
        'Content title': pinTitle,
        'Added to': workspace?.name,
        'Dashboard ID': workspace?.id,
        'Pin Status': pinStatus,
        ...(topicTitle && {
          'Topic Title': topicTitle
        })
      }, location && location);
    };
  }
}), _class);
export default new PanelStore();